import { ModalOptions } from 'types/global'
import { Button, Container, Icon, Modal, Spacer, Text } from 'roadie-ui'
import { LocalizedText } from 'localization'

export const SubmittedModal: React.FC<{
  modalOptions: ModalOptions
  isWebView?: boolean
  linkTo?: string
  modalDescription?: string
}> = ({ modalOptions, isWebView, linkTo, modalDescription }) => {
  return (
    <Modal.Basic open={modalOptions?.modalOpen} width={!isWebView ? '500px' : '350px'}>
      <Container.Base>
        <Container.Position $position="absolute" $top="1.4rem" $right="1.4rem">
          <Button.Link.Tertiary type="button" id="appeal-status-link" to={linkTo || '/dashboard'}>
            <Icon.Close $width="2rem" $height="2rem" $color="neutral-darker" />
          </Button.Link.Tertiary>
        </Container.Position>
      </Container.Base>
      <Spacer $height="2.4rem" />
      <Text.H4 $fontWeight="700" $color="neutral-black">
        <LocalizedText translationKey="dweb_common_submitted" />
      </Text.H4>
      <Spacer $height="2.4rem" />
      <Icon.CheckmarkCircle $color="primary-light" $width="6rem" $height="6rem" />
      <Spacer $height="2.4rem" />
      <Text.Body1>{modalDescription}</Text.Body1>
      <Spacer $height="2.4rem" />
      <Button.Link.Primary $width="100%" type="button" id="appeal-status-link" to={linkTo || '/dashboard'}>
        <LocalizedText translationKey="dweb_common_close" />
      </Button.Link.Primary>
      <Spacer $height="2.4rem" />
    </Modal.Basic>
  )
}
